import React, { Component } from 'react';
import Form from "./form";
import Ubicacion from "./ubicacion";
import credential from "./credential";


const mapURL = `https://maps.googleapis.com/maps/api/js?v=3.exp&key=${credential.mapsKey}`;
class Main extends Component {
  constructor(props) {
    super(props);
    this.state = {
        email:'',
        name:'',
        descripcion:'',
        modal1: false,
        label :'Ingresa tu email',
        error: ''
    }
  }  
 
  render() {
    return (
      <main>
        <section className="intro" id="acerca" name="acerca">
            <h2>Acerca de nosotros</h2>
            <div>
             <p>Somos una empresa comercializadora de servicios de Telecomunicaciones orgullosamente Yecuateca, dedicada a proveer servicios de acceso a internet, de manera inalámbrica, (a través de radioenlaces).<br/> Llegando a zonas rurales difíciles de acceder, donde los grandes proveedores de servicios de telecomunicaciones no llegan.</p>
            </div>
        </section>

        <div className="services" id="servicios" name="servicios">
                <div className="service-one">
                <p className="service-icon"><i className="fas fa-home"></i>Planes residenciales</p>
                <p className="service-title"></p>
                   <ul className="service-lista" style={{marginTop:'1.5%'}}>
                   <li>Básico:<span>10 mbps $300.00 </span></li>
                   <li>Medio:<span> 20 mbps $549.00</span></li>
                   <li>Alto:<span> 50 mbps $699.00</span></li>
                  </ul>
                  <span className="ComentF">Instalación $800.00 a $1,500.00 depende de la localidad a instalar. (Incluye el primer mes de servicio)</span>
                </div>
                <div className="service-two">
                <p className="service-icon"><i className="far fa-building"></i>Planes comerciales</p>
                <p className="service-title"> </p>
            
                  <ul className="service-lista" style={{marginTop:'1.5%'}}>
                  <li>Bajo: <span> 15 mbps $499.00</span></li>
                  <li>Medio:<span> 30 mbps $699.00</span></li>
                  <li>Alto:<span> 60 mbps $899.00</span></li>
                  </ul>
                   <span className="ComentF">Instalación $1,500.00 a $2,000.00 depende de la localidad a instalar. (Incluye el primer mes de servicio)</span>
                </div>
                <div className="service-three" style={{marginTop:'1.5%'}}>
                <p className="service-icon" ><i className="fas fa-wifi"></i>Zonas WIFI HOTSPOT</p>
                <p className="service-title"></p>
                <p >Adquiere tu ficha de prepago en los diferentes puntos autorizados y disfruta de navegación ilimitada en tu móvil.</p>
              
          </div>
          </div>
          <div className="services" id="secondrow" style={{marginLeft:'32%',width:'100%'}}>
          <div className="service-four">
                <p className="service-icon"><i className="fas fa-project-diagram"></i>Proyectos</p>
                <p className="service-title" ></p>
         
                  <ul style={{width:'380px', listStyle: 'none',textAlign:'justify', marginTop:'-4%',marginLeft:'-10%',marginBottom:'34px', marginRight:'10px'}}>
                    <li style={{padding:'8px',textDecoration:'none'}}>Configuración e instalación de enlaces inalámbricos punto a punto, (consulte costos).</li>
                    <li style={{padding:'8px',textDecoration:'none'}}>Configuración e instalación de equipos para venta de fichas, (consulte costos).</li>
                  </ul>
            
              
          </div>
        </div>
        <section className="service-three" id="cobertura" name="cobertura" style={{marginTop:'-5%'}}>
            <h2>Cobertura</h2>
            <div>
              <br/><br/>
              <p style={{marginLeft:'-5%'}}>
                 <ul  className="Cobertura" style={{textDecoration:'none',textAlign:'left', marginTop:'-6%',margin:'0'}}>
                    <li>Arroyo de las Cañas, Yecuatla, Veracruz.</li>
                    <li>Arroyo Negro, Misantla, Veracruz.</li>
                    <li>Capulines, Yecuatla, Veracruz.</li>
                    <li>Cerro del tigre, Colipa, Veracruz.</li>
                    <li>Colipa, Veracruz.</li>
                    <li>Col. Benito Juárez, Yecuatla, Veracruz.</li>
                    <li>Comején, Misantla, Veracruz.</li>
                    <li>Cristóbal hidalgo, Yecuatla, Veracruz.</li>
                    <li>Cruz blanca, Yecuatla, Veracruz.</li>
                    <li>Cruz del porvenir, Yecuatla, Veracruz.</li>	
                    <li>Dos Caminos, Yecuatla, Veracruz.</li>
                    <li>El Chalahuite, Yecuatla, Veracruz.</li>
                    <li>El mirador, Yecuatla, Veracruz.</li>
                    <li>El Valle, Misantla, Veracruz.</li>
                    <li>La aurora, Yecuatla, Veracruz.</li>	
                    <li>La cachetada, Misantla, Veracruz.</li>
                    <li>La Capilla, Chinconquiaco, Veracruz.</li>
                    <li>Las Lajas, Yecuatla, Veracruz.</li>
                    <li>La Palma, Misantla, Veracruz.</li>
                    <li>La Piedad, Misantla, Veracruz.</li>
                    <li>La Piedrilla, Misantla, Veracruz.</li>
                    <li>La Reforma, (K9), Misantla, Veracruz.</li>
                    <li>La Unión, Yecuatla, Veracruz.</li>
                    <li>La Victoria, Yecuatla, Veracruz.</li>
                    <li>Leona vicario, Yecuatla, Veracruz.</li>
                    <li>Loma de San Agustín, Yecuatla, Veracruz.</li>
                    <li>Luz Bella, Yecuatla, Veracruz.</li>
                    <li>Mesa de Las Flores, Yecuatla, Veracruz.</li>
                    <li>Miraflores, Yecuatla, Veracruz.</li>
                    <li>Naranjos, Yecuatla, Veracruz.</li>
                    <li>Nueva Reforma, Yecuatla, Veracruz.</li>
                    <li>Paz de Enriquez, Yecuatla, Veracruz. </li>
                    <li>Plan Grande, Misantla, Veracruz.</li>
                    <li>Progreso de Juárez, Yecuatla, Veracruz.</li> 
                    <li>Roca de oro, Yecuatla, Veracruz.</li>
                    <li>Santa Julia, Yecuatla, Veracruz.</li>
                    <li>Santa Margarita, Misantla, Veracruz.</li>
                    <li>Santa Rita, Yecuatla, Veracruz.</li>
                    <li>Venustiano Carranza, Misantla, Veracruz.</li>
                    <li>Yecuatla, Veracruz.</li>
                  </ul>
                </p>
                <p className="ComentF" style={{width:'80%'}}>(Si tu comunidad o municipio no se encuentra en la lista,comunícate con nosotros para corroborar cobertura).</p>
              </div>
        </section>
        <div className="gallery" id="galeria" name="galeria">
         <div className="gallery-item-one"></div>
         <div className="gallery-item-two"></div>
         <div className="gallery-item-three"></div>
         <div className="gallery-item-four"></div>
         <div className="gallery-item-five"></div>
         <div className="gallery-item-six"></div>
        </div>
        <div><a className="contact more" href="/galeria" >Ver más</a></div>

        <section id="mision" name="mision">
            <h2>Misión</h2>
            <div>
              <p>Es proveerte de servicios de acceso a internet, de alta calidad, con equipos de última generación, y así lograr la satisfacción de nuestros usuarios, tratando día a día de mejorar la calidad de nuestro servicio, para cumplir con sus requerimientos cotidianos y así posicionarnos como una empresa lider y de alto nivel en el ramo de las comunicaciones.</p>
              </div>
              <h2>Visión</h2>
              <div>
              <p>Obtener el liderazgo de nuestros servicios en nuestra área, utilizando innovación tecnológica que nos permita no solo ser una empresa líder, sino adaptarnos rápidamente a cualquier cambio que pueda haber en el plano de las telecomunicaciones.</p>
              </div>
        </section>


        <section id="contacto" name="contacto">
            <h2>Contacto</h2>
            <Form />
        </section>

        <section id="ubicacion" name="ubicacion">
            <h2>Ubicación</h2>
            <p><strong>Calle 5 de mayo s/n, Cristóbal Hidalgo, Yecuatla, Veracruz. c.p. 93900 col. centro</strong><br/>
Horario: lunes a viernes: de 9:00 am. a 6:00 pm.<br/>
Sábado y domingo cerrado.<br/>
Soporte: de 9:00-20:00 horas lunes a viernes<br/>
Sábado y domingo solo facebook-whatsapp.
</p>
            <Ubicacion
              googleMapURL = {mapURL}
              containerElement = {<div className="mapContainer"/>}
              mapElement = {<div className="mapElement"/>}
              loadingElement = {<p>Cargando</p>}
             className="Mubicacion"/>
        </section>
      </main>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/components/main.js